import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pure pipe for formatting time strings from "HHmm" to "HH:mm".
 * Angular caches pure pipes — unlike method calls in templates,
 * this will only re-evaluate when the input value actually changes.
 *
 * Usage: {{ row.start | formatTime }}
 */
@Pipe({
  name: 'formatTime',
  pure: true
})
export class FormatTimePipe implements PipeTransform {
  transform(time: string | null | undefined): string {
    if (time == null) return '';
    const trimmed = time.trim();
    if (trimmed === '') return '';
    return trimmed.substring(0, 2) + ':' + trimmed.substring(2, 4);
  }
}
